/**
 * DoorwarePRO+ trade application — browser-local pending state for guests.
 * Staff approval/denial is authoritative via Shopify customer tags.
 */
(function () {
  var STORAGE_KEY = 'dw_trade_application_pending';

  function markPending() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (err) {}
  }

  function hasPending() {
    try {
      return !!localStorage.getItem(STORAGE_KEY);
    } catch (err) {
      return false;
    }
  }

  function clearPending() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (err) {}
  }

  function initApplicationPage() {
    var form = document.getElementById('dw-trade-application-form');
    if (!form) return;

    var posted =
      /(?:^|[?&])contact_posted=true(?:&|$)/.test(window.location.search) ||
      !!form.querySelector('.form-success');

    if (posted) {
      markPending();
      var ok = form.querySelector('.form-success');
      if (ok && ok.scrollIntoView) {
        ok.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  function initStatusPage() {
    var root = document.querySelector('[data-dw-trade-status-root]');
    if (!root) return;

    if (root.getAttribute('data-dw-trade-approved') === 'true') {
      clearPending();
      return;
    }

    if (/(?:^|[?&])contact_posted=true(?:&|$)/.test(window.location.search)) {
      markPending();
    }

    if (!hasPending()) return;

    var guest = root.querySelector('[data-dw-trade-status-guest]');
    var cached = root.querySelector('[data-dw-trade-status-cached-pending]');
    var applyPanel = root.querySelector('[data-dw-trade-status-apply]');
    var serverPending = root.querySelector('.dw-account-trade-status__panel--pending:not([data-dw-trade-status-cached-pending] .dw-account-trade-status__panel--pending)');
    var serverApproved = root.querySelector('.dw-account-trade-status__panel--approved');

    if (serverApproved || serverPending) return;

    if (guest) guest.hidden = true;
    if (applyPanel) applyPanel.hidden = true;
    if (cached) cached.hidden = false;
  }

  window.dwTradePendingLocal = {
    markPending: markPending,
    hasPending: hasPending,
    clearPending: clearPending
  };

  document.addEventListener('DOMContentLoaded', function () {
    initApplicationPage();
    initStatusPage();
  });
})();
